import * as React from "react";

import Layout from "../../components/Layout";
import styled from "styled-components";

import * as backupApi from "../../api/backup";
import { createLanguage } from "../../api/lang";

import { Spinner, Button, TextInput } from "@hubper/core-ui/elements";
import { SelectBox } from "@hubper/core-ui/components";
import useNotify from "@hubper/core-ui/hooks/useNotify";

import { Header } from "@hubper/core-ui/typo";

/**
 * Styles
 */

const Main = styled.div``;

/**
 * Main
 */

type State = {
  loading: boolean;
  availableBackups: backupApi.Backup[];
  selectedBackup: number | null;
  newLanguage: string;
};

function Settings() {
  const [state, setState] = React.useState<State>({
    loading: true,
    availableBackups: [],
    selectedBackup: null,
    newLanguage: ""
  });

  React.useEffect(() => {
    backupApi
      .getAvailableBackups()
      .then(availableBackups =>
        setState({ ...state, loading: false, availableBackups })
      );
  }, []);

  const notify = useNotify();

  return (
    <Layout
      bodyStyle={{
        position: "relative",
        display: "flex"
      }}
    >
      <Main>
        <h1 style={{ margin: 0 }}>Settings</h1>

        {state.loading ? (
          <Spinner />
        ) : (
          <>
            <Header
              style={{ marginBottom: 16, marginTop: 24, display: "block" }}
            >
              Backup
            </Header>

            <SelectBox
              label="Select a version"
              value={state.selectedBackup as any}
              options={state.availableBackups.map(x => ({
                value: x.id,
                display: x.title
              }))}
              // @ts-ignore
              onChange={id => setState(s => ({ ...s, selectedBackup: id }))}
              style={{
                marginTop: 12,
                width: 400,
                boxSizing: "border-box"
              }}
            />
            <Button
              disabled={!state.selectedBackup}
              text="Restore"
              type="color"
              style={{ marginTop: 16 }}
              onClick={async () => {
                setState(s => ({ ...s, selectedBackup: null }));

                await backupApi.restoreBackup(state.selectedBackup!.toString());

                notify({
                  title: "Backup restored",
                  description: state.availableBackups.find(
                    x => x.id === state.selectedBackup!
                  )!.title,
                  type: "success",
                  timeout: 2000
                });
              }}
            />

            <Header style={{ marginBottom: 24, marginTop: 36 }}>
              Add new language
            </Header>

            <TextInput
              label="Language code"
              placeholder="E.g. nl"
              value={state.newLanguage}
              onChange={(evt: any) =>
                setState({ ...state, newLanguage: evt.target.value })
              }
            />

            <Button
              disabled={!state.newLanguage}
              text="Create"
              type="color"
              style={{ marginTop: 24 }}
              onClick={async () => {
                await createLanguage(state.newLanguage);

                notify({
                  title: "Created new language",
                  description: state.newLanguage,
                  type: "success",
                  timeout: 2000
                });

                setState(s => ({ ...s, newLanguage: "" }));
              }}
            />
          </>
        )}
      </Main>
    </Layout>
  );
}

export default Settings;
